import findResult, { assignProps, compareByAttributes } from '@/utils/resultsHelper';
import { readStates, states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { responseError } from '@/utils/errors';

const initialState = {
  workflows: {
    lookups: {
      enabledFlag: true,
      disabledFlag: false,
      results: [],
      ...readStates,
    },
    open: {
      results: [],
    },
  },
};

export const workflowCompare = (a, b) => compareByAttributes(a, b, 'workflow.name');

export const workflowSections = (names = ['project', 'about']) => {
  const sections = { sections: {} };
  names.forEach((name) => {
    sections.sections[name] = { label: '', fields: [] };
  });

  return sections;
};

export const openWorkflow = ({ code }) => ({
  code,
  readStatus: states.PENDING,
  readErrors: [],
  ...workflowSections(),
});

export const findWorkflows = ({ workflows }, { category }) => workflows[category];

export const findWorkflow = ({ workflows }, { category, code }) => findResult(workflows, category, code);

export const fetchWorkflowState = withDraft((draft, action) => {
  const item = findWorkflow(draft, action);
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.workflows[action.category].results.push(openWorkflow(action));
  }
});

export const showWorkflowState = (draft, { category, code, result }) => {
  const item = findWorkflow(draft, { category, code });
  const props = { ...result, readStatus: states.SUCCESS, readErrors: [] };
  if (item) {
    assignProps(item, props);
  } else { draft.workflows[category].results.push(props); }
};

export const showWorkflowErrorState = withDraft((draft, action) => {
  const item = findWorkflow(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

export default initialState;
